import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cx } from "@/lib/cx";

import "./ui.css";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "onNavy" | "navy";
  size?: "md" | "sm";
  /** Icoon links van het label. Krijgt automatisch `aria-hidden`. */
  icon?: ReactNode;
};

export function Button({
  variant = "secondary",
  size = "md",
  icon,
  children,
  className,
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx("atl-button", `atl-button--${variant}`, size === "sm" && "atl-button--sm", className)}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
